import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import { FilterConfig } from "../schemas";
import { MobileFilterOrchestrator } from "./MobileFilterOrchestrator/MobileFilterOrchestrator";
import { DesktopFilterOrchestrator } from "./DesktopFilterOrchestrator/DesktopFilterOrchestrator";
import { useIsMobile } from "@/hooks/use-mobile";
type Props = {
  filters: FilterConfig[];
  pageKey: string;
  trailingActions?: ReactNode;
  mobileHeader?: ReactNode;
  barPrefix?: ReactNode;
  hideClearAll?: boolean;
};
export function FilterOrchestrator(t0) {
  const $ = _c(9);
  const {
    filters,
    pageKey,
    trailingActions,
    mobileHeader,
    barPrefix,
    hideClearAll
  } = t0;
  const isMobile = useIsMobile();
  if (isMobile) {
    let t1;
    if ($[0] !== filters || $[1] !== mobileHeader || $[2] !== pageKey) {
      t1 = <MobileFilterOrchestrator filters={filters} pageKey={pageKey} mobileHeader={mobileHeader} />;
      $[0] = filters;
      $[1] = mobileHeader;
      $[2] = pageKey;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== barPrefix || $[5] !== filters || $[6] !== hideClearAll || $[7] !== trailingActions) {
    t1 = <DesktopFilterOrchestrator filters={filters} trailingActions={trailingActions} barPrefix={barPrefix} hideClearAll={hideClearAll} data-sentry-element="DesktopFilterOrchestrator" data-sentry-component="FilterOrchestrator" data-sentry-source-file="FilterOrchestrator.tsx" />;
    $[4] = barPrefix;
    $[5] = filters;
    $[6] = hideClearAll;
    $[7] = trailingActions;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}